import { cn } from "@/utils/cn";
import { memo, ReactNode } from "react";

interface OnboardingRoundBackgroundProps {
  classNames?: {
    container?: string;
    header?: string;
    gradient?: string;
    content?: string;
  };
  header?: ReactNode;
  children?: ReactNode;
}

export const OnboardingRoundBackground = memo(
  function OnboardingRoundBackground({
    classNames,
    header,
    children,
  }: OnboardingRoundBackgroundProps) {
    return (
      <div
        className={cn(
          "relative max-h-screen flex flex-col items-center w-full h-full bg-screen-built overflow-hidden",
          classNames?.container,
        )}
      >
        {header && (
          <div className={cn("flex-1 z-10 relative", classNames?.header)}>
            {header}
          </div>
        )}

        <div
          className={cn(
            "absolute bottom-0 left-0 right-0 z-0",
            classNames?.gradient,
          )}
        >
          <div
            className={cn(
              "absolute left-1/2 -translate-x-1/2 bottom-1/2 translate-y-1/2",
              "w-[100vh] h-[100vh] rounded-full bg-gradient-to-b from-white to-gray-50",
            )}
          />
        </div>

        {children && (
          <div className={cn("flex-1 z-[100] relative", classNames?.content)}>
            {children}
          </div>
        )}
      </div>
    );
  },
);
